"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeakAuthClient_1 = __importStar(require("./PeakAuthClient"));
const PeakAuthConstants_1 = __importDefault(require("../utilities/PeakAuthConstants"));
class PeakAuthResetClient {
    constructor(client = new PeakAuthClient_1.default()) {
        this.client = client;
        this.endpoint = "api/reset";
        this.requestEndpoint = "api/reset/request";
        this.passwordEndpoint = "api/reset/password";
    }
    requestAsync(mailAddress, service, redirectUri) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.requestEndpoint,
                queryStrings: {
                    mailAddress,
                    [PeakAuthConstants_1.default.service]: this.client.resolver.service(service),
                    [PeakAuthConstants_1.default.redirectUri]: this.client.resolver.redirectUri(redirectUri)
                }
            });
        });
    }
    request(mailAddress, service, redirectUri) {
        return PeakAuthClient_1.asapScheduled(this.requestAsync(mailAddress, service, redirectUri));
    }
    passwordAsync(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.passwordEndpoint,
                body: model
            });
        });
    }
    password(model) {
        return PeakAuthClient_1.asapScheduled(this.passwordAsync(model));
    }
    postAsync(model, requestCode) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.postAsync({
                path: this.endpoint,
                body: model,
                queryStrings: { [PeakAuthConstants_1.default.requestCode]: this.client.resolver.requestCode(requestCode) }
            });
        });
    }
    post(model, requestCode) {
        return PeakAuthClient_1.asapScheduled(this.postAsync(model, requestCode));
    }
}
exports.default = PeakAuthResetClient;
